'use client'

import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { ContextMenuDivider } from '../../../../molecules/ContextMenu/ContextMenuDivider'
import { SelectFilterProps } from '..'
import { ComponentTranslationContext } from '../../../../../providers'
import { FilterValue, SelectOption } from '../../../../../types'
import { MESSAGE_KEYS } from '../../../../../constants/messageKeys'
import { useSelectFilter } from '../../hooks/useSelectFilter'
import { ContextMenuSelectFilterOption } from './ContextMenuSelectFilterOption'
import { Spinner } from '../../../../atoms'

const EMPTY_VALUE = ''

/**
 * A version of a select filter that can be used in a context menu.
 */
export const ContextMenuSelectFilter = ({
    label,
    options,
    name,
    width,
    isClearable,
    defaultValue = EMPTY_VALUE,
    isLoading,
}: SelectFilterProps): ReactElement => {
    const { selectedValue, setSelectedValue } = useSelectFilter(name, defaultValue)
    const [selectOptions, setSelectOptions] = useState<SelectOption[]>([])
    const { getLabel } = useContext(ComponentTranslationContext)

    const getOptions = (): SelectOption[] => {
        if (!!options?.length) {
            if (isClearable) {
                let newOptions = options ? [...options] : []

                newOptions?.unshift({ label: getLabel(MESSAGE_KEYS.ALL), value: EMPTY_VALUE })
                return newOptions
            }
            return options
        }
        return []
    }

    useEffect(() => {
        if (!selectOptions.length && !!options?.length) setSelectOptions(getOptions())
    }, [options])

    const select = (value: FilterValue) => {
        setSelectedValue(value)
    }

    return (
        <>
            <ContextMenuDivider label={label} />
            {isLoading && <Spinner className="mx-auto my-2" />}
            {selectOptions?.map((option, index) => {
                return (
                    <ContextMenuSelectFilterOption
                        key={`${option.value}-${index}`}
                        onClick={() => select(option.value)}
                        isSelected={option.value === selectedValue}
                    >
                        {option.label}
                    </ContextMenuSelectFilterOption>
                )
            })}
        </>
    )
}
